<template>
  <v-row>
    <v-col cols="12">
      <v-card class="rp-card" flat>
        <!-- ================= HEADER BAND ================= -->
        <div class="rp-header pl-base-bg">
          <div class="rp-header-left">
            <v-avatar size="48" class="rp-avatar">
              <span class="white--text text-h5">
                {{ payment?.userId?.name?.charAt(0)?.toUpperCase() }}
              </span>
            </v-avatar>
            <div>
              <div class="rp-title">{{ payment?.userId?.name || "-" }}</div>
              <div class="rp-subtitle">{{ payment?.userId?.email || "-" }}</div>
            </div>
          </div>

          <div class="rp-header-right">
            <v-chip
              :color="statusColor"
              dark
              small
              class="text-uppercase font-weight-bold rp-status-chip"
            >
              {{ payment?.status }}
            </v-chip>
          </div>
        </div>

        <div class="pa-6">
          <!-- ================= PAYMENT DETAILS ================= -->
          <div class="rp-section-label">Payment Details</div>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <div class="rp-info-card">
                <div class="rp-info-label">
                  <v-icon size="14" class="mr-1">mdi-currency-inr</v-icon>
                  Amount
                </div>
                <div class="rp-info-value">{{ formatAmount(payment?.amount) }}</div>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <div class="rp-info-card">
                <div class="rp-info-label">
                  <v-icon size="14" class="mr-1">mdi-cash</v-icon>
                  Currency
                </div>
                <div class="rp-info-value">{{ payment?.currency || "-" }}</div>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <div class="rp-info-card">
                <div class="rp-info-label">
                  <v-icon size="14" class="mr-1">mdi-check-decagram-outline</v-icon>
                  Verification Source
                </div>
                <div class="rp-info-value text-capitalize">
                  {{ payment?.verificationSource || "-" }}
                </div>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <div class="rp-info-card">
                <div class="rp-info-label">
                  <v-icon size="14" class="mr-1">mdi-calendar-check-outline</v-icon>
                  Verified At
                </div>
                <div class="rp-info-value">{{ formatDate(payment?.verifiedAt) }}</div>
              </div>
            </v-col>
          </v-row>

          <!-- ================= RAZORPAY IDENTIFIERS ================= -->
          <div class="rp-section-label mt-6">Razorpay Identifiers</div>
          <v-row>
            <v-col cols="12" sm="6">
              <div class="rp-info-card">
                <div class="rp-info-label">
                  <v-icon size="14" class="mr-1">mdi-receipt-text-outline</v-icon>
                  Order ID
                </div>
                <div class="rp-info-value rp-mono">{{ payment?.razorpayOrderId || "-" }}</div>
              </div>
            </v-col>

            <v-col cols="12" sm="6">
              <div class="rp-info-card">
                <div class="rp-info-label">
                  <v-icon size="14" class="mr-1">mdi-credit-card-outline</v-icon>
                  Payment ID
                </div>
                <div class="rp-info-value rp-mono">{{ payment?.razorpayPaymentId || "-" }}</div>
              </div>
            </v-col>

            <v-col cols="12">
              <div class="rp-info-card">
                <div class="rp-info-label">
                  <v-icon size="14" class="mr-1">mdi-shield-key-outline</v-icon>
                  Signature
                </div>
                <div class="rp-info-value rp-mono rp-break-all">
                  {{ payment?.razorpaySignature || "-" }}
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- ================= SUBSCRIPTION IMPACT ================= -->
          <div class="rp-section-label mt-6">Subscription Impact</div>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <div class="rp-info-card">
                <div class="rp-info-label">
                  <v-icon size="14" class="mr-1">mdi-calendar-remove-outline</v-icon>
                  Previous Expiry
                </div>
                <div class="rp-info-value">{{ formatDate(payment?.previousExpiryDate) }}</div>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <div class="rp-info-card">
                <div class="rp-info-label">
                  <v-icon size="14" class="mr-1">mdi-calendar-plus-outline</v-icon>
                  New Expiry
                </div>
                <div class="rp-info-value">{{ formatDate(payment?.newExpiryDate) }}</div>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <div class="rp-info-card">
                <div class="rp-info-label">
                  <v-icon size="14" class="mr-1">mdi-calendar-clock-outline</v-icon>
                  Paid On
                </div>
                <div class="rp-info-value">{{ formatDate(payment?.createdAt) }}</div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ViewRenewalPayment",

  data() {
    return {
      payment: null,
    };
  },

  async created() {
    const id = this.$route.params.id;
    this.payment = await this.$store.dispatch(
      "renewalPayments/getRenewalPaymentById",
      id
    );
  },

  computed: {
    statusColor() {
      const colors = {
        verified: "green",
        paid: "blue",
        created: "blue",
        failed: "red",
      };
      return colors[this.payment?.status] || "grey";
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },

    formatAmount(amount) {
      if (amount == null) return "-";
      return `₹${(amount / 100).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
      })}`;
    },
  },
};
</script>

<style scoped>
.rp-card {
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(15, 30, 50, 0.1);
}

/* ================= HEADER BAND ================= */
.rp-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 20px;
}

.rp-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.rp-avatar {
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  background: rgba(255, 255, 255, 0.16);
}

.rp-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.01em;
}

.rp-subtitle {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 2px;
}

.rp-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.rp-status-chip {
  letter-spacing: 0.04em;
}

/* ================= SECTIONS ================= */
.rp-section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  margin-bottom: 12px;
}

.rp-info-card {
  background: #f8fafc;
  border: 1px solid #eef1f5;
  border-radius: 0;
  padding: 14px 16px;
  height: 100%;
}

.rp-info-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
}

.rp-info-value {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.rp-mono {
  font-family: "Roboto Mono", monospace;
  font-size: 13px;
}

.rp-break-all {
  word-break: break-all;
}

@media (max-width: 600px) {
  .rp-header {
    padding: 12px 14px;
  }

  .pa-6 {
    padding: 16px !important;
  }
}
</style>
